// extracted by mini-css-extract-plugin
module.exports = {"root":"BackSearchButton_root__d9jPr","icon":"BackSearchButton_icon__ERyPD","text":"BackSearchButton_text__0TRRy","textShort":"BackSearchButton_textShort__Tw1Cx"};